import React from 'react';
import Modal from 'react-bootstrap/Modal';
import useMain from '../../../hooks/useMain';
import Image from './../../common/image';

function InfoModal({ onClose, show, title, body }) {
	const { theme } = useMain();
	return (
		<Modal
			contentClassName={`bg-${theme}`}
			centered
			show={show}
			onHide={onClose}>
			<Modal.Header
				closeVariant={theme === 'dark' ? 'white' : undefined}
				closeButton>
				<Modal.Title className='d-flex aling-items-center'>
					<Image
						height='40px'
						className='me-2'
						fileName={`logo/icon_${theme}.webp`}
					/>
					<span>{title}</span>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>{body}</Modal.Body>
			<Modal.Footer className='d-flex justify-content-evenly align-items-center'>
				<button
					onClick={() => onClose(false)}
					className={`btn btmn-sm btn-set2-${theme} px-4`}>
					Ok
				</button>
			</Modal.Footer>
		</Modal>
	);
}

export default InfoModal;
